import React from 'react';
import './Hero.css';
import { FaMobileAlt, FaCode, FaRocket } from 'react-icons/fa';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="hero-content fade-in-up">
          <div className="hero-text">
            <h1>
              Building <span className="highlight">Mobile Apps</span> That Matter
            </h1>
            <p>
              Flutter & iOS developer specializing in production-ready mobile applications. 
              From healthcare to e-commerce, I transform ideas into scalable digital solutions.
            </p>
            <div className="hero-buttons">
              <a href="#contact" className="btn btn-primary">Get Started</a>
              <a href="#portfolio" className="btn btn-secondary">View Projects</a>
            </div>
          </div>
          
          <div className="hero-image">
            <div className="hero-illustration">
              <FaMobileAlt className="hero-icon" />
              <div className="floating-icons">
                <FaCode className="float-icon icon-1" />
                <FaRocket className="float-icon icon-2" />
              </div>
            </div>
          </div>
        </div>
        
        <div className="stats fade-in-up">
          <div className="stat-item">
            <h3>11+</h3>
            <p>Apps Published</p>
          </div>
          <div className="stat-item">
            <h3>7+</h3>
            <p>Production Projects</p>
          </div>
          <div className="stat-item">
            <h3>3+</h3>
            <p>Years Experience</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
